module.exports = __webpack_public_path__ + "h5/img/Conference.c4b522ad.jpg";